import { makeStyles } from "@mui/styles";

export const responsiveStyle = makeStyles((theme) => {
    return {
        titleContainer: {
            alignItems: "left",
            justifyContent: "flex-start",
            [theme.breakpoints.down("sm")]: {
                alignItems: "flex-start",
                justifyContent: "left",
            },
        },
    };
});
